module.exports = __webpack_public_path__ + "70f4d584adafcc8cad2e362441f38171.jpg";